import React, {Component} from 'react';
import SlateIframe from 'components/SlateIframe/SlateIframe';
import './styles.css';

class SlatePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      colors: [],
    };
  }

  handleColorChange = (colors) => {
    this.setState({colors: colors});
  }

  render() {
    var params = this.props.match.params;
    var slateUUID = params.slateUUID;
    var imageUrl = params.imageUrl;

    return (
      <div
        className="slate-full-page-container"
        style={{
          backgroundColor: this.state.colors.length > 0 ? this.state.colors[this.state.colors.length - 1] : '#001b32c7',
          transition: "all .3s ease",
          WebkitTransition: "all .3s ease",
          MozTransition: "all .3s ease",
        }}
      >
        <SlateIframe
          slateUUID={slateUUID}
          imageUrl={imageUrl}
          isDisableEditingAllField={true}
          wrapClassName="slate-full-page-wrap slate-full-page-for-not-pane-wrap"
          iframeClassName="slate-full-page slate-full-page-for-not-pane"
          onColorChange={this.handleColorChange}
        />
      </div>
    );
  }
}

export default SlatePage;
